import { render, staticRenderFns } from "./PdfSplitter.vue?vue&type=template&id=313529a2&scoped=true"
import script from "./PdfSplitter.vue?vue&type=script&lang=js"
export * from "./PdfSplitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313529a2",
  null
  
)

export default component.exports